const imgIcon ={
    offlineLogo: require('../offline-icon.svg'),
    offlineIcon: require('../offline_Icon.png')
}

export default imgIcon;